import { useTranslation } from "react-i18next"
import { AlertDialogProps } from "@radix-ui/react-alert-dialog"
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { DELETE_RESTRICTION_TIMEOUT } from "@/modules/patients/constants/Agenda"

interface ConfirmDialogProps extends AlertDialogProps {
  onConfirm?(event: React.MouseEvent<HTMLElement>): void
}

const TimeWindowRestrictedDialog = ({ onConfirm, ...otherProps }: ConfirmDialogProps) => {
  const { t } = useTranslation()

  return (
    <AlertDialog {...otherProps} data-testid="time-window-delete-dialog">
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("patient.agenda.timeWindowForm.deleteRestrictionTitle")}</AlertDialogTitle>
          <AlertDialogDescription className="text-on-surface-subdued">
            {t("patient.agenda.timeWindowForm.deleteRestrictionMessage", {
              limit: DELETE_RESTRICTION_TIMEOUT,
              time_measurement: DELETE_RESTRICTION_TIMEOUT > 1 ? "minutes" : "minute",
            })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onConfirm}>{t("common.button.ok")}</AlertDialogCancel>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export { TimeWindowRestrictedDialog }
